export function toFixed(num: number, decimalDigit = 3) {
  // maximum 4 digit decimal. eg 0.0895
  // convert to float to remove the trailing zero. eg 0.0890 will be 0.089
  return parseFloat(num.toFixed(decimalDigit));
}
